"use client";

import NextLink from "next/link";
import { MDXButton as Button } from "@appsignal-tools/design-system";

export default function MDXButton({ ...props }) {
  return <Button internalLinkElement={NextLink} {...props} />;
}
